import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetBlockedAddresses = (queryParams: any) =>
    request({
        url: ApiURL.Query.GetBlockedAddresses,
        method: RequestType.GET,
        params: queryParams,
    });

const CargoAddressBlockingQuery = {
    GetBlockedAddresses,
};

export default CargoAddressBlockingQuery;
